module.exports = __webpack_public_path__ + "static/media/Attendance.6b6caf9d.svg";